import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { FETCH_PAGE_CONFIGURATION_NAME } from './pageConfigurationBreadcrumb.query';

export const PageConfigurationBreadcrumb = () => {
  const { id } = useParams();
  const { data } = useQuery(FETCH_PAGE_CONFIGURATION_NAME, {
    variables: { pageConfigurationId: id ?? '' },
    skip: !id,
  });

  return data?.fetchPageConfiguration?.pageConfiguration?.name ?? '';
};
